/*=========================================================================================
  File Name: mutations.js
  Description: App State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
========================================================================================== */
export default {
  CHANGED_RESTAURANT_STATE (state, payload) {
    console.log("CHANGED_RESTAURANT_STATE")
    console.log(payload);
    console.log(payload)
    // if restaurant is selected, set the stat
    if (payload.restaurantName !== '') {
      state.isRestaurantSelected = true;
      state.selectedRestaurant = payload.restaurantName;
    }
  },

  CHANGE_NETWORK_ERROR_STATE (state, payload) {
    state.networkError = payload;
  },

  CHANGE_FAVOURITE_SELECTED_STATE (state, payload) {
    state.isFavouriteSelected = payload;
  }
}
